module.exports = __webpack_public_path__ + "img/home-sidebar-collapsed.21c857c2.jpg";